import { render, staticRenderFns } from "./barcode_scanner.vue?vue&type=template&id=3dddd7c4&scoped=true&"
import script from "./barcode_scanner.vue?vue&type=script&lang=js&"
export * from "./barcode_scanner.vue?vue&type=script&lang=js&"
import style0 from "./barcode_scanner.vue?vue&type=style&index=0&id=3dddd7c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dddd7c4",
  null
  
)

export default component.exports